'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const DashIcon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6 12a1 1 0 001 1h10a1 1 0 100-2H7a1 1 0 00-1 1z" fill="currentColor" /></svg>);